export default __webpack_public_path__ + "static/media/fruit-1920w.71e46c75.avif";